// (function () {
//     // Check if the module exists before doing anything
//     const {{module_name_camel}}Exists = !!document.querySelector('.stories');

//     // If the module exists, do whatever we need to
//     if ({{module_name_camel}}Exists) {
//         // Your code here
//     }

// })();
